export const env = (key: string) => {
  const value = import.meta.env[key];
  if (!value) throw new Error(`Env ${key} not found`);
  return value;
};
